import sha1 from 'sha1'

//加密
export function encrypt(str){
    return sha1(`sas_${str}`);
  }